export default {
  state: {
    letterJacketContent: window.pageData.catalogDetails.letterJacketContent,
    selectedPatch: null
  },
  mutations: {
    setSelectedPatch: (state, selectedPatch) => {
      state.selectedPatch = selectedPatch
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/letter-jackets/catalog-details/store.js